import dynamic from "next/dynamic";
import * as React from "react";
import PropTypes from "prop-types";
import { Waypoint } from "react-waypoint";
import cs from "classnames";
import { ErrorBoundary } from "@lululemon/mwa-logger";
import { productEdHandleError } from "@lululemon/ecom-common/src/util/product-education-logger";

import CdpHero from "../cdp-hero/cdp-hero";
import styles from "./product-list-top-content.module.scss";

const HeroCardsTabpanel = dynamic(() =>
  import("../cdp-hero-cards/hero-cards-tabpanel/hero-cards-tabpanel")
);
const HeroCardsCarousel = dynamic(() =>
  import("../cdp-hero-cards/hero-cards-carousel/hero-cards-carousel")
);

const ProductListTopContent = ({
  productTopListContent,
  isMobile,
  onTopComponentPositionChange,
  headerHeight,
  isBraQuizPage,
  bp,
  refresh,
  location,
  isMarkdown,
  variant,
}) => {
  return (
    <ErrorBoundary
      onError={(error) =>
        productEdHandleError(error, variant, "ProductListTopContent")
      }
    >
      {variant === "titledCollection" && (
        <div className={styles.heroCardsContainer}>
          <p
            className={cs(
              styles.productTopListContentTitle,
              styles.bopisCountSwap,
              {
                "lll-font-weight-medium": isMobile,
                "lll-text-body-1": isMobile,
                "lll-text-medium": !isMobile,
              }
            )}
          >
            {productTopListContent?.fields?.title}
          </p>
          <HeroCardsCarousel
            cards={productTopListContent?.fields.components}
            isMobile={isMobile}
            showPagination={isMobile}
            isHeroCardsCarousel
          />
        </div>
      )}

      {variant === "webTabpanel" && (
        <Waypoint
          onPositionChange={onTopComponentPositionChange}
          topOffset={`${headerHeight}px`}
        >
          <div>
            <HeroCardsTabpanel
              {...productTopListContent?.fields}
              isMobile={isMobile}
              isBraQuizPage={isBraQuizPage}
            />
          </div>
        </Waypoint>
      )}

      {variant === "cdpHero" && (
        <Waypoint
          onPositionChange={onTopComponentPositionChange}
          topOffset={`${headerHeight}px`}
        >
          <div>
            <CdpHero
              data={productTopListContent?.fields}
              isMarkdown={isMarkdown}
              currentBreakpoint={bp}
              currentPage={location}
              refresh={refresh}
              ctaTrack={isBraQuizPage ? "bra-quiz-cta-hero" : null}
            />
          </div>
        </Waypoint>
      )}
    </ErrorBoundary>
  );
};

ProductListTopContent.propTypes = {
  productTopListContent: PropTypes.any,
  isMobile: PropTypes.bool,
  onTopComponentPositionChange: PropTypes.func,
  headerHeight: PropTypes.number,
  isBraQuizPage: PropTypes.bool,
  bp: PropTypes.string,
  refresh: PropTypes.bool,
  location: PropTypes.string,
  isMarkdown: PropTypes.bool,
  variant: PropTypes.string,
};

export default ProductListTopContent;
